import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import apex from '../../apex';
import { openModal, MODAL_TYPES } from './modalActions';
export var GET_API_INFO = 'GET_API_INFO';
export var RECEIVE_VALIDATE_2FA_REQUIRED_ENDPOINTS = 'RECEIVE_VALIDATE_2FA_REQUIRED_ENDPOINTS';
export var receiveValidate2FARequiredEndpoints = function receiveValidate2FARequiredEndpoints(payload) {
  return {
    type: RECEIVE_VALIDATE_2FA_REQUIRED_ENDPOINTS,
    payload: payload
  };
};
export var getApiInfo = function getApiInfo() {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getState, OMSId, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState = getState(), OMSId = _getState.user.userInfo.OMSId;
              _context.next = 3;
              return apex.connection.RPCPromise('GetValidate2FARequiredEndpoints', {
                OMSId: OMSId
              });
            case 3:
              data = _context.sent;
              if (data) dispatch(receiveValidate2FARequiredEndpoints(JSON.parse(data.o)));
            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var callAPI = function callAPI(endpoint, apiPayload) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var state, validate2FARequiredEndpoints, apiCall, res;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = getState();
              validate2FARequiredEndpoints = state.api.validate2FARequiredEndpoints;
              if (!validate2FARequiredEndpoints[endpoint.toLowerCase()]) {
                _context3.next = 5;
                break;
              }
              apiCall = function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return apex.connection.RPCPromise(endpoint, data);
                        case 2:
                          return _context2.abrupt('return', _context2.sent);
                        case 3:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this);
                }));
                return function apiCall(_x5) {
                  return _ref3.apply(this, arguments);
                };
              }();
              return _context3.abrupt('return', new Promise(function (resolve, reject) {
                dispatch(openModal(MODAL_TYPES.REQUIRE_2FA, {
                  apiPayload: JSON.stringify(apiPayload),
                  apiCall: apiCall,
                  resolve: resolve,
                  reject: reject
                }));
              }));
            case 5:
              _context3.next = 7;
              return apex.connection.RPCPromise(endpoint, apiPayload);
            case 7:
              res = _context3.sent;
              return _context3.abrupt('return', JSON.parse(res.o));
            case 9:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};